// Centralized API endpoint configuration
export const ENDPOINTS = {
  // Lead submission
  LEAD_POST: 'https://bluemodomedia.leadspediatrack.com/post.do',
  LP_PIXEL: 'https://2u76bw6o7t3dpvhg45iwfoykvq0ewsgs.lambda-url.us-east-2.on.aws/&request_id=',

  // Location services
  LOCATION_WORKER: 'https://fragrant-fog-f988.ryan-v-0b2.workers.dev/',
  IPSTACK: 'https://api.ipstack.com/check?access_key=df027d9a9416448d23a42df11a08961c',

  // Array (credit bureau) data
  ARRAY: 'https://bgjjnsl2r6awqh4mznd2ywwo3y0bvafx.lambda-url.us-east-2.on.aws/',

  // BlueShift data capture Lambda (formerly labeled ActiveCampaign)
  BLUESHIFT_DATA: 'https://7nf2fxp2rksxslo4y5nlowihza0vidwh.lambda-url.us-east-2.on.aws/',

  // BlueShift events Lambda
  BLUESHIFT_EVENTS: 'https://v2lr4cqaqyogu34ykwy7ivjtd40rfbac.lambda-url.us-east-2.on.aws/',

  // Call center routing
  CALL_CENTER: 'https://bluemodo.waypointsoftware.com/capture2.php',

  // Analytics/tracking
  TRACKING: 'https://oqsf6awdaglglx6knym6hyquqm0nmtmh.lambda-url.us-east-2.on.aws/',

  // Everflow
  EVERFLOW_SDK: 'https://www.fpplk8trk.com/scripts/sdk/everflow.js',
}
